import { Box, Center, HStack, Heading, Image, VStack } from '@chakra-ui/react'
import React from 'react'

const SkillBox = ({skillObject}) => {
  return (
    
    <HStack   justify="center" wrap="wrap" gap="40px">
    {Object.keys(skillObject).map((skill, id) => (
        <VStack
          bg="#FAFAFA"
          boxShadow="0px 10px 20px rgba(0, 0, 0, 0.12)"
          borderRadius="10px"
          w={{base:"90px",lg:"145px"}}
          h={{base:"90px",lg:"145px"}}
         
        
          justify="space-around"
          p="1rem"
           transition= "300ms ease-in-out"
          key={200 + id}
        >
            <Box   alignContent="center"> 
             {skill!=="Express"?<Image src={skillObject[skill]} alt={skill} w={{base:"40px",lg:"60px"}}h={{base:"40px",lg:"60px"}}/>:<Center boxShadow="2xl" fontSize={{base:"3xl",lg:"5xl"}}>ex</Center>}
             </Box>
        
          <Heading size={{base:"xs",lg:"sm"}}>{skill}</Heading>
        </VStack>
      ))}
      </HStack>
  )
}

export default SkillBox